import { render, staticRenderFns } from "./IssueTypeAutocomplete.vue?vue&type=template&id=48b02a22&"
import script from "./IssueTypeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./IssueTypeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports